import { useQuery, QueryFunctionContext } from '@tanstack/react-query';
import { axiosGlobalInstance } from 'api/axios/global';
import { routes } from 'api/routes';

const get = async ({ queryKey }: QueryFunctionContext<[string, string]>) => {
  const [, invitationCode] = queryKey;
  const { data } = await axiosGlobalInstance.get(
    `${routes['invitations']}/${invitationCode}/accept`,
  );
  return data;
};

export const getAcceptInvitation = async (invitationCode: string) => {
  const { data } = await axiosGlobalInstance.get(
    `${routes['invitations']}/${invitationCode}/accept`,
  );
  return data;
};

const useGetAcceptInvitation = (
  invitationCode: string,
  enabled: boolean,
  onSuccess: () => void,
  onError: () => void,
) => {
  return useQuery({
    queryKey: [`${routes['invitations']}/accept`, invitationCode],
    queryFn: get,
    enabled,
    // eslint-disable-next-line @tanstack/query/no-deprecated-options
    onSuccess,
    // eslint-disable-next-line @tanstack/query/no-deprecated-options
    onError,
  });
};

export default useGetAcceptInvitation;
